const defaultMessageError = 'Este campo es obligatorio';
const validator = {
  tipoSolicitud: {
    rules: [
      {
        test: (value) => {
          return (typeof(value) !== 'undefined' && value !== null && value !== '');
        },
        message: defaultMessageError,
      },
    ],
    errors: [],
    valid: false,
    state: '',
    exclude: false
  },
  nvehi: {
    rules: [
      {
        test: (value) => {
          return value >= 1;
        },
        message: 'Ingrese una cantidad mayor a 0.',
      },
    ],
    errors: [],
    valid: false,
    state: '',
    exclude: false
  },
  pedidos: {
    rules: [
      {
        test: (value) => {
          return (typeof(value) !== 'undefined' && value !== null && value !== '' && value.length > 0);
        },
        message: defaultMessageError,
      },
    ],
    errors: [],
    valid: false,
    state: '',
    exclude: false
  },
  obsExcep: {
    rules: [
      {
        test: (value) => {
          return (typeof(value) !== 'undefined' && value !== null && value !== '');
        },
        message: defaultMessageError,
      },
    ],
    errors: [],
    valid: false,
    state: '',
    exclude: false
  },
  fechaExcep: {
    rules: [
      {
        test: (value) => {
          return (typeof(value) !== 'undefined' && value !== null && value !== '');
        },
        message: defaultMessageError,
      },
    ],
    errors: [],
    valid: false,
    state: '',
    exclude: false
  },
  responsable: {
    rules: [
      {
        test: (value) => {
          return (typeof(value) !== 'undefined' && value !== null && value !== '');
        },
        message: defaultMessageError,
      },
    ],
    errors: [],
    valid: false,
    state: '',
    exclude: false
  }
};

export default validator;



// WEBPACK FOOTER //
// ./src/pages/modals/SolicitudExcepcional/validators.js